import { Button, Modal, CircularProgress } from "@material-ui/core";
import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { withTranslation } from "~/i18n";
import { connect } from "react-redux";
import { compose } from "recompose";
import useStyles from "./styles";
import { hideLogoutModal } from "../../helpers/general";
import { destroyUserCookie } from "../../helpers/cookie";

function LogoutModal(props) {
  const classes = useStyles();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const { widthType, t, userReducer } = props;

  const handleLogout = async () => {
    try {
      setLoadingSubmit(true);
      localStorage.removeItem("userProfile");
      await destroyUserCookie(undefined, "logout-modal");

      localStorage.removeItem("userProfile");
      localStorage.removeItem("planQuestionaire");
      setTimeout(() => {
        window.location.reload();
        hideLogoutModal();
      }, 3000);
    } catch (err) {
      console.log("FAILED LOGOUT");
    }
  };

  function getWidthModal() {
    if (widthType === "medium") {
      return classes.middleWidth;
    }
    return null;
  }

  return (
    <Modal
      open={userReducer.isOpen}
      // open
      onClose={hideLogoutModal}
      aria-labelledby="modal-confirmation"
      aria-describedby="confirmation"
      className={classes.rootContainer}
    >
      <div className={clsx(classes.ctnModal, getWidthModal())}>
        <span id="title">{userReducer.title || t("myfitsociety:logout")}</span>
        <span id="desc">
          {userReducer.subtitle || t("myfitsociety:sure-logout")}
        </span>
        <div className={classes.rowStyle}>
          <Button disabled={loadingSubmit} onClick={handleLogout}>
            {loadingSubmit ? (
              <CircularProgress className={classes.circularStyle} size={18} />
            ) : (
              t("myfitsociety:yes")
            )}
          </Button>
          <Button
            disabled={loadingSubmit}
            className={classes.btnNo}
            onClick={hideLogoutModal}
          >
            {t("myfitsociety:no")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

LogoutModal.propTypes = {
  t: PropTypes.func.isRequired,
  userReducer: PropTypes.object.isRequired,
};

LogoutModal.defaultProps = {
  widthType: "small",
};

const mapStateToProps = (state) => ({
  userReducer: state.userReducer.modalLogout,
});

const enhancer = compose(
  withTranslation(["myfitsociety"]),
  connect(mapStateToProps)
);

export default enhancer(LogoutModal);
